import React from 'react';
import history from 'app/routes/history';
import { Badge } from 'reactstrap';
import { parseAmount } from 'app/utils/parsers';

import IconButton from 'app/components/general/IconButton';
import ReminderIcon from 'app/images/icons/reminder.svg';

interface IPaymentRowProps {
  collectedTeamMembers?: number;
  pendingTeamMembers?: number;
  payment?: any;
  selectPayment?: Function;
  createReminder?: Function;
  reminders?: any;
  amount?: number;
  identifier?: string;
}

interface IPaymentRowState {
  reminderPopoverOpen: boolean;
  tooltipOpen: boolean;
}

export default class PaymentRow extends React.Component<IPaymentRowProps, IPaymentRowState> {
  static defaultProps: IPaymentRowProps = {
    identifier: '',
    reminders: {},
  };

  onClick = (): void => {
    this.props.selectPayment(this.props.payment.id);
    history.push(`/payments/${this.props.payment.id}`);
  };

  toggleReminderPopover = (): void => {
    this.setState((previousState) => ({
      reminderPopoverOpen: !previousState.reminderPopoverOpen,
    }));
  };

  toggleTooltip = (): void => {
    this.setState((previousState) => ({
      tooltipOpen: !previousState.tooltipOpen,
    }));
  };

  handleReminder = (event): void => {
    event.stopPropagation();
    if (!this.props.reminders.isLoading) {
      this.props.createReminder({
        payments: [
          {
            id: this.props.identifier,
          },
        ],
      });
    }
  };

  renderReminderButton = (): React.ReactNode => (
    <div className="btn-flex-container thin-margin">
      <div
        className={this.props.pendingTeamMembers !== 0 ? 'd-block' : 'd-none'}
      >
        <IconButton
          icon={ReminderIcon}
          id={`id${this.props.identifier}`}
          tooltipText="Send SMS Reminder"
          className="btn-2 icon-button icon btn"
          onClick={this.handleReminder}
        >
          Remind
        </IconButton>
        {/* <UncontrolledTooltip
          placement="right"
          isOpen={this.state.tooltipOpen}
          target="share-link-input"
        >
          Send an SMS reminder.
        </UncontrolledTooltip> */}
      </div>
    </div>
  );

  render(): React.ReactNode {
    let badgeColor = 'red';
    if (this.props.pendingTeamMembers === 0) {
      badgeColor = 'green';
    }
    return (
      <div
        className="row content-row"
        onClick={this.onClick}
        // onMouseEnter={this.handleMouseEnter}
        // onMouseLeave={this.handleMouseLeave}
      >
        <div className="col col-5 col-md-4">
          {this.props.payment.description}
        </div>
        <div className="col col-3 col-md-3 d-none d-md-block">
          {parseAmount(this.props.amount)}
        </div>
        <div className="col col-3 col-md-2">
          <Badge className="negative-margin" color={badgeColor}>
            {`${this.props.collectedTeamMembers} of ${
              this.props.pendingTeamMembers + this.props.collectedTeamMembers
            }`}
          </Badge>
        </div>
        <div className="col col-4 col-md-3 btn-flex-group">
          {this.renderReminderButton()}
        </div>
      </div>
    );
  }
}
